// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#workbench-canvas {
  grid-column: 1;
  grid-row: 1;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  font: 14px "acumin-pro-condensed";
  cursor: default;
  user-select: none;
  overflow: hidden;
  background-image: linear-gradient(to right, #4f4e4f 1px, transparent 1px), linear-gradient(to bottom, #4f4e4f 1px, transparent 1px);
}
#workbench-canvas #selection-container {
  pointer-events: none;
}
#workbench-canvas #selection-container .selection-box {
  z-index: 10;
  background: rgba(72, 72, 196, 0.5);
  border: blue solid 2px;
}
#workbench-canvas #workbench-container {
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  transform-origin: left top;
  display: grid;
  grid-template-rows: 100%;
  grid-template-columns: 100%;
}
#workbench-canvas #workbench-container #frame-container {
  overflow: visible;
  grid-row: 1;
  grid-column: 1;
  position: relative;
  width: 100%;
  height: 100%;
}
#workbench-canvas #workbench-container .frame-box {
  position: absolute;
  background: rgba(72, 72, 72, 0.7);
  display: grid;
  grid-template-rows: 40px calc(100% - 40px);
  grid-template-columns: 100%;
  box-sizing: border-box;
}
#workbench-canvas #workbench-container .frame-box.collapsed {
  height: auto !important;
  width: 200px !important;
  z-index: 3;
}
#workbench-canvas #workbench-container .frame-box.collapsed .frame-box-header {
  font-size: 16px;
  grid-template-columns: calc(100% - 37px) 30px 7px;
}
#workbench-canvas #workbench-container .frame-box.collapsed .frame-box-header .frame-box-header-collapse {
  margin-top: -2px;
}
#workbench-canvas #workbench-container .frame-box.collapsed .frame-box-header .frame-box-header-close {
  display: none;
}
#workbench-canvas #workbench-container .frame-box.collapsed .frame-comments.has-comments .frame-comment-span {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
#workbench-canvas #workbench-container .frame-box .frame-box-border {
  grid-row: 1/span 2;
  grid-column: 1;
  width: 100%;
  height: 100%;
  border: transparent solid 4px;
  pointer-events: none;
  box-sizing: border-box;
}
#workbench-canvas #workbench-container .frame-box .frame-box-header {
  grid-row: 1;
  grid-column: 1;
  background: rgb(72, 72, 72);
  color: white;
  font-size: 24px;
  text-align: center;
  display: grid;
  grid-template-rows: 100%;
  grid-template-columns: calc(100% - 74px) 30px 7px 30px 7px;
  align-content: center;
  overflow: hidden;
}
#workbench-canvas #workbench-container .frame-box .frame-box-header .frame-box-header-button {
  cursor: pointer;
  align-self: center;
  transform-origin: 50% 50%;
  transform: scale(1);
  stroke: transparent;
  fill: white;
  display: grid;
}
#workbench-canvas #workbench-container .frame-box .frame-box-header .frame-box-header-button.down {
  transform: scale(0.9);
}
#workbench-canvas #workbench-container .frame-box .frame-box-header .frame-box-header-collapse {
  grid-column: 2;
  grid-row: 1;
}
#workbench-canvas #workbench-container .frame-box .frame-box-header .frame-box-header-close {
  grid-column: 4;
  grid-row: 1;
}
#workbench-canvas #workbench-container .frame-box .frame-box-header .frame-box-header-title {
  grid-column: 1;
  grid-row: 1;
  display: grid;
  height: 100%;
  width: 100%;
  align-self: stretch;
  align-items: center;
  margin-top: -2px;
}
#workbench-canvas #workbench-container .frame-box .frame-comments.has-comments {
  display: grid;
  grid-row: 2;
  grid-column: 1;
  padding: 0 10px;
  font-style: italic;
  word-wrap: break-word;
}
#workbench-canvas #workbench-container .frame-box.selected .frame-box-border {
  border-color: white;
}
#workbench-canvas #workbench-container .frame-box .right-handle {
  grid-area: 1/2/3/2;
  width: 4px;
  background-color: transparent;
  cursor: ew-resize;
}
#workbench-canvas #workbench-container .frame-box .right-handle::after {
  content: "";
  width: 8px;
  position: absolute;
  top: 0;
  bottom: 0;
  margin-left: -4px;
  cursor: ew-resize;
}
#workbench-canvas #workbench-container .frame-box .right-handle.collapsed {
  cursor: pointer;
}
#workbench-canvas #workbench-container .frame-box .top-right-corner-handle {
  background-color: transparent;
  height: 4px;
  z-index: 21;
  cursor: ne-resize;
  width: 4px;
  margin-left: -6px;
}
#workbench-canvas #workbench-container .frame-box .top-right-corner-handle::after {
  background-color: transparent;
  cursor: ne-resize;
  margin-left: unset;
  top: -4px;
  height: 10px;
  width: 10px;
}
#workbench-canvas #workbench-container .frame-box .bottom-right-corner-handle {
  background-color: transparent;
  height: 0px;
  z-index: 21;
  cursor: nw-resize;
  grid-area: 4/2/4/2;
  margin-left: -2px;
}
#workbench-canvas #workbench-container .frame-box .bottom-right-corner-handle::after {
  background-color: transparent;
  height: 10px;
  cursor: nw-resize;
  top: unset;
  bottom: -4px;
  width: 10px;
}
#workbench-canvas #workbench-container .frame-box .left-handle {
  grid-area: 1/1/3/1;
  width: 4px;
  background-color: transparent;
  cursor: ew-resize;
}
#workbench-canvas #workbench-container .frame-box .left-handle::before {
  content: "";
  width: 8px;
  position: absolute;
  top: 0;
  bottom: 0;
  margin-left: -4px;
}
#workbench-canvas #workbench-container .frame-box .top-left-corner-handle {
  background-color: transparent;
  height: 4px;
  z-index: 21;
  cursor: nw-resize;
  width: 4px;
  margin-left: -4px;
}
#workbench-canvas #workbench-container .frame-box .top-left-corner-handle::before {
  background-color: transparent;
  cursor: nw-resize;
  margin-left: unset;
  top: -4px;
  height: 10px;
  width: 10px;
}
#workbench-canvas #workbench-container .frame-box .bottom-left-corner-handle {
  background-color: transparent;
  height: 0px;
  z-index: 21;
  cursor: sw-resize;
  grid-area: 4/1/4/1;
}
#workbench-canvas #workbench-container .frame-box .bottom-left-corner-handle::before {
  background-color: transparent;
  height: 10px;
  cursor: sw-resize;
  top: unset;
  bottom: -4px;
  width: 10px;
}
#workbench-canvas #workbench-container .frame-box .top-handle {
  grid-area: 1/1/1/1;
  background-color: transparent;
  height: 4px;
  cursor: ns-resize;
}
#workbench-canvas #workbench-container .frame-box .top-handle::before {
  content: "";
  width: 100%;
  position: absolute;
  top: -4px;
  bottom: 100%;
  right: 0;
  left: 0;
  margin-bottom: -8px;
  cursor: ns-resize;
  height: 8px;
}
#workbench-canvas #workbench-container .frame-box .bottom-handle {
  grid-area: 3/1/3/1;
  background-color: transparent;
  height: 4px;
  cursor: ns-resize;
}
#workbench-canvas #workbench-container .frame-box .bottom-handle::after {
  content: "";
  width: 100%;
  position: absolute;
  top: 100%;
  bottom: 0;
  right: 0;
  left: 0;
  margin-top: -8px;
  cursor: ns-resize;
  height: 12px;
}
#workbench-canvas #workbench-container .frame-box.collapsed .top-handle,
#workbench-canvas #workbench-container .frame-box.collapsed .top-right-corner-handle,
#workbench-canvas #workbench-container .frame-box.collapsed .right-handle,
#workbench-canvas #workbench-container .frame-box.collapsed .bottom-right-corner-handle,
#workbench-canvas #workbench-container .frame-box.collapsed .bottom-handle,
#workbench-canvas #workbench-container .frame-box.collapsed .bottom-left-corner-handle,
#workbench-canvas #workbench-container .frame-box.collapsed .left-handle,
#workbench-canvas #workbench-container .frame-box.collapsed .top-left-corner-handle {
  cursor: default;
}
#workbench-canvas #workbench-container .frame-box.collapsed .right-handle::after,
#workbench-canvas #workbench-container .frame-box.collapsed .bottom-handle::after,
#workbench-canvas #workbench-container .frame-box.collapsed .top-right-corner-handle::after,
#workbench-canvas #workbench-container .frame-box.collapsed .bottom-right-corner-handle::after {
  cursor: default;
}
#workbench-canvas #workbench-container .frame-box.collapsed .left-handle::before,
#workbench-canvas #workbench-container .frame-box.collapsed .top-handle::before,
#workbench-canvas #workbench-container .frame-box.collapsed .top-left-corner-handle::before,
#workbench-canvas #workbench-container .frame-box.collapsed .bottom-left-corner-handle::before {
  cursor: default;
}
#workbench-canvas #workbench-container #workbench-svg-container {
  grid-row: 1;
  grid-column: 1;
  position: relative;
  width: 100%;
  height: 100%;
  overflow: visible;
  pointer-events: none;
  z-index: 2;
}
#workbench-canvas #workbench-container #workbench-svg-container .link {
  stroke-width: 4px;
}
#workbench-canvas #workbench-container #workbench-svg-container .link.selected {
  stroke: white !important;
  stroke-dasharray: 10, 2;
}
#workbench-canvas #workbench-container #workbench-svg-container .link.hidden {
  display: none;
}
#workbench-canvas #workbench-container #workbench-svg-container .selection-link {
  pointer-events: all;
  stroke-width: 16px;
  opacity: 0;
  transition: opacity 75ms;
  stroke: transparent;
  cursor: pointer;
}
#workbench-canvas #workbench-container #workbench-svg-container .selection-link.hidden {
  display: none;
}
#workbench-canvas #workbench-container #workbench-svg-container .selection-link:hover, #workbench-canvas #workbench-container #workbench-svg-container .selection-link.selected {
  stroke: white !important;
  opacity: 0.4;
}
#workbench-canvas #workbench-container #workbench-canvas-container {
  grid-row: 1;
  grid-column: 1;
  position: relative;
  width: 100%;
  height: 100%;
}
#workbench-canvas #workbench-container #workbench-canvas-container .visual {
  z-index: 4;
  width: 200px;
  position: absolute;
  left: 0;
  top: 0;
  background: gray;
  border: 4px solid black;
  border-radius: 12px;
  display: grid;
  grid-template-rows: 30px auto;
  grid-template-columns: 100%;
  color: white;
}
#workbench-canvas #workbench-container #workbench-canvas-container .visual.hidden {
  display: none;
}
#workbench-canvas #workbench-container #workbench-canvas-container .visual .comments {
  position: absolute;
  top: -50px;
  width: 200px;
  height: 45px;
  overflow: hidden;
  font-style: italic;
  opacity: 0.8;
  display: grid;
  align-items: flex-end;
  pointer-events: none;
}
#workbench-canvas #workbench-container #workbench-canvas-container .visual .selection-border {
  grid-row: 1/span 3;
  grid-column: 1;
  margin: -4px;
  transition: border-color 100ms;
  border: 4px solid black;
  border-radius: 12px;
}
#workbench-canvas #workbench-container #workbench-canvas-container .visual.selected .selection-border {
  border-color: white;
}
#workbench-canvas #workbench-container #workbench-canvas-container .visual .header {
  grid-row: 1;
  grid-column: 1;
  border: 4px solid black;
  border-top-right-radius: 7px;
  border-top-left-radius: 7px;
  font-size: 16px;
  text-align: center;
  margin-top: -1px;
  margin-left: -1px;
  margin-right: -1px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  background: black;
  color: white;
}
#workbench-canvas #workbench-container #workbench-canvas-container .visual .header.constant {
  border-color: #464348;
  background: #464348;
}
#workbench-canvas #workbench-container #workbench-canvas-container .visual .header.inspector {
  border-color: #66491b;
  background: #66491b;
}`, "",{"version":3,"sources":["webpack://./../../../tools/guiEditor/dist/diagram/workbenchCanvas.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,iCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EAEA,mIAAA;AAAJ;AAEI;EACI,oBAAA;AAAR;AAEQ;EACI,WAAA;EACA,kCAAA;EACA,sBAAA;AAAZ;AAII;EACI,WAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,0BAAA;EACA,aAAA;EACA,wBAAA;EACA,2BAAA;AAFR;AAIQ;EACI,iBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAFZ;AAKQ;EACI,kBAAA;EACA,iCAAA;EACA,aAAA;EACA,0CAAA;EACA,2BAAA;EACA,sBAAA;AAHZ;AAKY;EACI,uBAAA;EACA,uBAAA;EACA,UAAA;AAHhB;AAKgB;EACI,eAAA;EACA,iDAAA;AAHpB;AAKoB;EACI,gBAAA;AAHxB;AAMoB;EACI,aAAA;AAJxB;AASoB;EACI,mBAAA;EACA,uBAAA;EACA,gBAAA;AAPxB;AAYY;EACI,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,oBAAA;EACA,sBAAA;AAVhB;AAaY;EACI,WAAA;EACA,cAAA;EACA,2BAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,wBAAA;EACA,0DAAA;EACA,qBAAA;EACA,gBAAA;AAXhB;AAagB;EACI,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;AAXpB;AAaoB;EACI,qBAAA;AAXxB;AAegB;EACI,cAAA;EACA,WAAA;AAbpB;AAgBgB;EACI,cAAA;EACA,WAAA;AAdpB;AAiBgB;EACI,cAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAfpB;AAmBY;EACI,aAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;AAjBhB;AAqBgB;EACI,mBAAA;AAnBpB;AAuBY;EACI,kBAAA;EACA,UAAA;EACA,6BAAA;EACA,iBAAA;AArBhB;AAuBgB;EACI,WAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,iBAAA;EACA,iBAAA;AArBpB;AAwBgB;EACI,eAAA;AAtBpB;AA0BY;EACI,6BAAA;EACA,WAAA;EACA,WAAA;EACA,iBAAA;EACA,UAAA;EACA,iBAAA;AAxBhB;AA0BgB;EACI,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;AAxBpB;AA4BY;EACI,6BAAA;EACA,WAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AA1BhB;AA4BgB;EACI,6BAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;AA1BpB;AA8BY;EACI,kBAAA;EACA,UAAA;EACA,6BAAA;EACA,iBAAA;AA5BhB;AA8BgB;EACI,WAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,iBAAA;AA5BpB;AAgCY;EACI,6BAAA;EACA,WAAA;EACA,WAAA;EACA,iBAAA;EACA,UAAA;EACA,iBAAA;AA9BhB;AAgCgB;EACI,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;AA9BpB;AAkCY;EACI,6BAAA;EACA,WAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AAhChB;AAkCgB;EACI,6BAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;AAhCpB;AAoCY;EACI,kBAAA;EACA,6BAAA;EACA,WAAA;EACA,iBAAA;AAlChB;AAoCgB;EACI,WAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,QAAA;EACA,OAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AAlCpB;AAsCY;EACI,kBAAA;EACA,6BAAA;EACA,WAAA;EACA,iBAAA;AApChB;AAsCgB;EACI,WAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AApCpB;AAyCgB;;;;;;;;EAQI,eAAA;AAvCpB;AA8CoB;;;;EACI,eAAA;AAzCxB;AAiDoB;;;;EACI,eAAA;AA5CxB;AAkDQ;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;EACA,UAAA;AAhDZ;AAkDY;EACI,iBAAA;AAhDhB;AAiDgB;EACI,wBAAA;EACA,uBAAA;AA/CpB;AAkDgB;EACI,aAAA;AAhDpB;AAoDY;EACI,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,wBAAA;EACA,mBAAA;EACA,eAAA;AAlDhB;AAoDgB;EACI,aAAA;AAlDpB;AAqDgB;EAEI,wBAAA;EACA,YAAA;AApDpB;AAyDQ;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAvDZ;AAyDY;EACI,UAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,6BAAA;EACA,2BAAA;EACA,YAAA;AAvDhB;AAyDgB;EACI,aAAA;AAvDpB;AA0DgB;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,oBAAA;AAxDpB;AA2DgB;EACI,kBAAA;EACA,cAAA;EACA,YAAA;EAEA,8BAAA;EAEA,uBAAA;EACA,mBAAA;AA3DpB;AA+DoB;EACI,mBAAA;AA7DxB;AAiEgB;EACI,WAAA;EACA,cAAA;EACA,uBAAA;EACA,4BAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AA/DpB;AAiEoB;EACI,qBAAA;EACA,mBAAA;AA/DxB;AAkEoB;EACI,qBAAA;EACA,mBAAA;AAhExB","sourcesContent":["#workbench-canvas {\r\n    grid-column: 1;\r\n    grid-row: 1;\r\n    width: 100%;\r\n    height: 100%;\r\n    margin: 0;\r\n    padding: 0;\r\n    font: 14px \"acumin-pro-condensed\";\r\n    cursor: default;\r\n    user-select: none;\r\n    overflow: hidden;\r\n\r\n    background-image: linear-gradient(to right, #4f4e4f 1px, transparent 1px), linear-gradient(to bottom, #4f4e4f 1px, transparent 1px);\r\n\r\n    #selection-container {\r\n        pointer-events: none;\r\n\r\n        .selection-box {\r\n            z-index: 10;\r\n            background: rgba(72, 72, 196, 0.5);\r\n            border: blue solid 2px;\r\n        }\r\n    }\r\n\r\n    #workbench-container {\r\n        width: 100%;\r\n        height: 100%;\r\n        left: 0;\r\n        top: 0;\r\n        transform-origin: left top;\r\n        display: grid;\r\n        grid-template-rows: 100%;\r\n        grid-template-columns: 100%;\r\n\r\n        #frame-container {\r\n            overflow: visible;\r\n            grid-row: 1;\r\n            grid-column: 1;\r\n            position: relative;\r\n            width: 100%;\r\n            height: 100%;\r\n        }\r\n\r\n        .frame-box {\r\n            position: absolute;\r\n            background: rgba(72, 72, 72, 0.7);\r\n            display: grid;\r\n            grid-template-rows: 40px calc(100% - 40px);\r\n            grid-template-columns: 100%;\r\n            box-sizing: border-box;\r\n\r\n            &.collapsed {\r\n                height: auto !important;\r\n                width: 200px !important;\r\n                z-index: 3;\r\n\r\n                .frame-box-header {\r\n                    font-size: 16px;\r\n                    grid-template-columns: calc(100% - 37px) 30px 7px;\r\n\r\n                    .frame-box-header-collapse {\r\n                        margin-top: -2px;\r\n                    }\r\n\r\n                    .frame-box-header-close {\r\n                        display: none;\r\n                    }\r\n                }\r\n\r\n                .frame-comments.has-comments {\r\n                    .frame-comment-span {\r\n                        white-space: nowrap;\r\n                        text-overflow: ellipsis;\r\n                        overflow: hidden;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .frame-box-border {\r\n                grid-row: 1 / span 2;\r\n                grid-column: 1;\r\n                width: 100%;\r\n                height: 100%;\r\n                border: transparent solid 4px;\r\n                pointer-events: none;\r\n                box-sizing: border-box;\r\n            }\r\n\r\n            .frame-box-header {\r\n                grid-row: 1;\r\n                grid-column: 1;\r\n                background: rgba(72, 72, 72, 1);\r\n                color: white;\r\n                font-size: 24px;\r\n                text-align: center;\r\n                display: grid;\r\n                grid-template-rows: 100%;\r\n                grid-template-columns: calc(100% - 74px) 30px 7px 30px 7px;\r\n                align-content: center;\r\n                overflow: hidden;\r\n\r\n                .frame-box-header-button {\r\n                    cursor: pointer;\r\n                    align-self: center;\r\n                    transform-origin: 50% 50%;\r\n                    transform: scale(1);\r\n                    stroke: transparent;\r\n                    fill: white;\r\n                    display: grid;\r\n\r\n                    &.down {\r\n                        transform: scale(0.9);\r\n                    }\r\n                }\r\n\r\n                .frame-box-header-collapse {\r\n                    grid-column: 2;\r\n                    grid-row: 1;\r\n                }\r\n\r\n                .frame-box-header-close {\r\n                    grid-column: 4;\r\n                    grid-row: 1;\r\n                }\r\n\r\n                .frame-box-header-title {\r\n                    grid-column: 1;\r\n                    grid-row: 1;\r\n                    display: grid;\r\n                    height: 100%;\r\n                    width: 100%;\r\n                    align-self: stretch;\r\n                    align-items: center;\r\n                    margin-top: -2px;\r\n                }\r\n            }\r\n\r\n            .frame-comments.has-comments {\r\n                display: grid;\r\n                grid-row: 2;\r\n                grid-column: 1;\r\n                padding: 0 10px;\r\n                font-style: italic;\r\n                word-wrap: break-word;\r\n            }\r\n\r\n            &.selected {\r\n                .frame-box-border {\r\n                    border-color: white;\r\n                }\r\n            }\r\n\r\n            .right-handle {\r\n                grid-area: 1 / 2 / 3 / 2;\r\n                width: 4px;\r\n                background-color: transparent;\r\n                cursor: ew-resize;\r\n\r\n                &::after {\r\n                    content: \"\";\r\n                    width: 8px;\r\n                    position: absolute;\r\n                    top: 0;\r\n                    bottom: 0;\r\n                    margin-left: -4px;\r\n                    cursor: ew-resize;\r\n                }\r\n\r\n                &.collapsed {\r\n                    cursor: pointer;\r\n                }\r\n            }\r\n\r\n            .top-right-corner-handle {\r\n                background-color: transparent;\r\n                height: 4px;\r\n                z-index: 21;\r\n                cursor: ne-resize;\r\n                width: 4px;\r\n                margin-left: -6px;\r\n\r\n                &::after {\r\n                    background-color: transparent;\r\n                    cursor: ne-resize;\r\n                    margin-left: unset;\r\n                    top: -4px;\r\n                    height: 10px;\r\n                    width: 10px;\r\n                }\r\n            }\r\n\r\n            .bottom-right-corner-handle {\r\n                background-color: transparent;\r\n                height: 0px;\r\n                z-index: 21;\r\n                cursor: nw-resize;\r\n                grid-area: 4 / 2 / 4 / 2;\r\n                margin-left: -2px;\r\n\r\n                &::after {\r\n                    background-color: transparent;\r\n                    height: 10px;\r\n                    cursor: nw-resize;\r\n                    top: unset;\r\n                    bottom: -4px;\r\n                    width: 10px;\r\n                }\r\n            }\r\n\r\n            .left-handle {\r\n                grid-area: 1 / 1 / 3 / 1;\r\n                width: 4px;\r\n                background-color: transparent;\r\n                cursor: ew-resize;\r\n\r\n                &::before {\r\n                    content: \"\";\r\n                    width: 8px;\r\n                    position: absolute;\r\n                    top: 0;\r\n                    bottom: 0;\r\n                    margin-left: -4px;\r\n                }\r\n            }\r\n\r\n            .top-left-corner-handle {\r\n                background-color: transparent;\r\n                height: 4px;\r\n                z-index: 21;\r\n                cursor: nw-resize;\r\n                width: 4px;\r\n                margin-left: -4px;\r\n\r\n                &::before {\r\n                    background-color: transparent;\r\n                    cursor: nw-resize;\r\n                    margin-left: unset;\r\n                    top: -4px;\r\n                    height: 10px;\r\n                    width: 10px;\r\n                }\r\n            }\r\n\r\n            .bottom-left-corner-handle {\r\n                background-color: transparent;\r\n                height: 0px;\r\n                z-index: 21;\r\n                cursor: sw-resize;\r\n                grid-area: 4 / 1 / 4 / 1;\r\n\r\n                &::before {\r\n                    background-color: transparent;\r\n                    height: 10px;\r\n                    cursor: sw-resize;\r\n                    top: unset;\r\n                    bottom: -4px;\r\n                    width: 10px;\r\n                }\r\n            }\r\n\r\n            .top-handle {\r\n                grid-area: 1 / 1 / 1 / 1;\r\n                background-color: transparent;\r\n                height: 4px;\r\n                cursor: ns-resize;\r\n\r\n                &::before {\r\n                    content: \"\";\r\n                    width: 100%;\r\n                    position: absolute;\r\n                    top: -4px;\r\n                    bottom: 100%;\r\n                    right: 0;\r\n                    left: 0;\r\n                    margin-bottom: -8px;\r\n                    cursor: ns-resize;\r\n                    height: 8px;\r\n                }\r\n            }\r\n\r\n            .bottom-handle {\r\n                grid-area: 3 / 1 / 3 / 1;\r\n                background-color: transparent;\r\n                height: 4px;\r\n                cursor: ns-resize;\r\n\r\n                &::after {\r\n                    content: \"\";\r\n                    width: 100%;\r\n                    position: absolute;\r\n                    top: 100%;\r\n                    bottom: 0;\r\n                    right: 0;\r\n                    left: 0;\r\n                    margin-top: -8px;\r\n                    cursor: ns-resize;\r\n                    height: 12px;\r\n                }\r\n            }\r\n\r\n            &.collapsed {\r\n                .top-handle,\r\n                .top-right-corner-handle,\r\n                .right-handle,\r\n                .bottom-right-corner-handle,\r\n                .bottom-handle,\r\n                .bottom-left-corner-handle,\r\n                .left-handle,\r\n                .top-left-corner-handle {\r\n                    cursor: default;\r\n                }\r\n\r\n                .right-handle,\r\n                .bottom-handle,\r\n                .top-right-corner-handle,\r\n                .bottom-right-corner-handle {\r\n                    &::after {\r\n                        cursor: default;\r\n                    }\r\n                }\r\n\r\n                .left-handle,\r\n                .top-handle,\r\n                .top-left-corner-handle,\r\n                .bottom-left-corner-handle {\r\n                    &::before {\r\n                        cursor: default;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        #workbench-svg-container {\r\n            grid-row: 1;\r\n            grid-column: 1;\r\n            position: relative;\r\n            width: 100%;\r\n            height: 100%;\r\n            overflow: visible;\r\n            pointer-events: none;\r\n            z-index: 2;\r\n\r\n            .link {\r\n                stroke-width: 4px;\r\n                &.selected {\r\n                    stroke: white !important;\r\n                    stroke-dasharray: 10, 2;\r\n                }\r\n\r\n                &.hidden {\r\n                    display: none;\r\n                }\r\n            }\r\n\r\n            .selection-link {\r\n                pointer-events: all;\r\n                stroke-width: 16px;\r\n                opacity: 0;\r\n                transition: opacity 75ms;\r\n                stroke: transparent;\r\n                cursor: pointer;\r\n\r\n                &.hidden {\r\n                    display: none;\r\n                }\r\n\r\n                &:hover,\r\n                &.selected {\r\n                    stroke: white !important;\r\n                    opacity: 0.4;\r\n                }\r\n            }\r\n        }\r\n\r\n        #workbench-canvas-container {\r\n            grid-row: 1;\r\n            grid-column: 1;\r\n            position: relative;\r\n            width: 100%;\r\n            height: 100%;\r\n\r\n            .visual {\r\n                z-index: 4;\r\n                width: 200px;\r\n                position: absolute;\r\n                left: 0;\r\n                top: 0;\r\n                background: gray;\r\n                border: 4px solid black;\r\n                border-radius: 12px;\r\n                display: grid;\r\n                grid-template-rows: 30px auto;\r\n                grid-template-columns: 100%;\r\n                color: white;\r\n\r\n                &.hidden {\r\n                    display: none;\r\n                }\r\n\r\n                .comments {\r\n                    position: absolute;\r\n                    top: -50px;\r\n                    width: 200px;\r\n                    height: 45px;\r\n                    overflow: hidden;\r\n                    font-style: italic;\r\n                    opacity: 0.8;\r\n                    display: grid;\r\n                    align-items: flex-end;\r\n                    pointer-events: none;\r\n                }\r\n\r\n                .selection-border {\r\n                    grid-row: 1 / span 3;\r\n                    grid-column: 1;\r\n                    margin: -4px;\r\n\r\n                    transition: border-color 100ms;\r\n\r\n                    border: 4px solid black;\r\n                    border-radius: 12px;\r\n                }\r\n\r\n                &.selected {\r\n                    .selection-border {\r\n                        border-color: white;\r\n                    }\r\n                }\r\n\r\n                .header {\r\n                    grid-row: 1;\r\n                    grid-column: 1;\r\n                    border: 4px solid black;\r\n                    border-top-right-radius: 7px;\r\n                    border-top-left-radius: 7px;\r\n                    font-size: 16px;\r\n                    text-align: center;\r\n                    margin-top: -1px;\r\n                    margin-left: -1px;\r\n                    margin-right: -1px;\r\n                    white-space: nowrap;\r\n                    text-overflow: ellipsis;\r\n                    overflow: hidden;\r\n                    background: black;\r\n                    color: white;\r\n\r\n                    &.constant {\r\n                        border-color: #464348;\r\n                        background: #464348;\r\n                    }\r\n\r\n                    &.inspector {\r\n                        border-color: #66491b;\r\n                        background: #66491b;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
